import { render, staticRenderFns } from "./ImageSelector.vue?vue&type=template&id=b4fa2df2&scoped=true"
import script from "./ImageSelector.vue?vue&type=script&lang=js"
export * from "./ImageSelector.vue?vue&type=script&lang=js"
import style0 from "./ImageSelector.vue?vue&type=style&index=0&id=b4fa2df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fa2df2",
  null
  
)

export default component.exports